import {REGISTRATION_STATUS} from 'components/Community/common/constants';
import {URLS} from '../../../../common/community/constants';

export function checkIsEventOpened(status) {
    return status === REGISTRATION_STATUS.opened;
}

export function getFiltersQuery(services, city) {
    const query = {};
    if (services && services.length) {
        query.services = services.join(',');
    }

    if (city && Number(city)) {
        query.city = city;
    }

    return query;
}

export function getEventStatus({registrationStatus, date, stream, isCanceled, record}) {
    if (isCanceled) {
        return REGISTRATION_STATUS.canceled;
    }

    if (record) {
        return REGISTRATION_STATUS.record;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (Date.parse(date) < today) {
        return REGISTRATION_STATUS.past;
    }

    return stream ? REGISTRATION_STATUS.stream : registrationStatus;
}

export function addLinkBlankProps(linkProps) {
    return {
        target: '_blank',
        rel: 'noopener noreferrer',
        ...linkProps,
    };
}

export function getEventUrl(id, url) {
    return url ? url : `${URLS.events}/${id}`;
}
